export var DocumentAssistantChatAppraisalErrorSubcodes;
(function (DocumentAssistantChatAppraisalErrorSubcodes) {
    DocumentAssistantChatAppraisalErrorSubcodes["AlreadyGiven"] = "ERROR_DOCUMENT_CHAT_MESSAGE_APPRAISAL_ALREADY_GIVEN";
})(DocumentAssistantChatAppraisalErrorSubcodes || (DocumentAssistantChatAppraisalErrorSubcodes = {}));
